import { render } from "./Index.vue?vue&type=template&id=dc05da1c&scoped=true"
import script from "./Index.vue?vue&type=script&lang=js"
export * from "./Index.vue?vue&type=script&lang=js"

import "./Index.vue?vue&type=style&index=0&id=dc05da1c&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-dc05da1c"],['__file',"components/Customers/OpenChallenges/Index.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "dc05da1c"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('dc05da1c', __exports__)) {
    api.reload('dc05da1c', __exports__)
  }
  
  module.hot.accept("./Index.vue?vue&type=template&id=dc05da1c&scoped=true", () => {
    api.rerender('dc05da1c', render)
  })

}


export default __exports__